import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Validators } from 'core';
import { useDispatch, useSelector } from 'react-redux';

import Input from 'components/organisms/input';
import Button from 'components/molecules/button';
import FormError from 'components/molecules/form-error';
import { AuthActions, AuthSelectors } from 'common/config/store';
import { useIntl } from 'common/config/i18n';
import { StyledFormWrapper as WrapperForm } from 'common/styling/mixins';

interface FormValues {
  userName?: string;
  password?: string;
}
interface OtherProps {
  title?: string;
}

const Form = (props: FormValues & OtherProps) => {
  const { t } = useIntl();
  const dispatch = useDispatch();
  const [formFocused, setFormFocused] = useState(false);

  const formik = useFormik({
    initialValues: {
      userName: props.userName || '',
      password: props.password || '',
    },
    validate: (values) => Validators.login(values),
    onSubmit: (values) => {
      setFormFocused(false);
      dispatch(AuthActions.login({ userName: values.userName, password: values.password }));
    },
  });
  const status = useSelector(AuthSelectors.statusSelector);
  const error = useSelector(AuthSelectors.errorSelector);

  return (
    <form onSubmit={formik.handleSubmit}>
      <WrapperForm>
        <Input
          width="270px"
          upLabel={t('form', 'FORM_USERNAME')}
          name="userName"
          onChange={formik.handleChange}
          value={formik.values.userName}
          onFocus={() => setFormFocused(true)}
        />
        <FormError formik={formik} fieldName="userName" />
        <Input
          width="270px"
          upLabel={t('form', 'FORM_PASSWORD')}
          type="password"
          name="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          onFocus={() => setFormFocused(true)}
        />
        <FormError formik={formik} fieldName="password" />
      </WrapperForm>
      {error === 'CLIENT_ERROR' && !formFocused && <FormError message={t('form', 'FORM_CONNECT_ERROR')} />}
      <Button
        height="50px"
        width="100%"
        borderRadius="20px"
        disabled={!formik.isValid && Object.keys(formik.touched).length !== 0}
        loading={status === 'loading'}
        htmlType="submit"
      >
        {t('Buttons', 'CONNECT_BUTTON')}
      </Button>
    </form>
  );
};
export default Form;
